const PHRASES = ["From Intent to Impact", "CSR Capital, Coordinated", "Grassroots to Boardroom"];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#E3E9F2] bg-white py-10 lg:py-14"
      aria-label="From Intent to Impact"
    >
      <div className="animate-marquee-slow flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {PHRASES.map((p, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span
                  className={`whitespace-nowrap px-8 text-5xl font-extrabold uppercase leading-none tracking-tight sm:text-7xl lg:text-8xl ${
                    i % 2 === 0 ? "text-[#0E2A6B]/10" : "text-outline-navy"
                  }`}
                >
                  {p}
                </span>
                <span className="text-3xl text-[#E8862A] sm:text-4xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
